/**
 * @author      sammy.dowds@zumper.com (Sammy Dowds)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { useMemo } from 'react'
import { ListingCardSizes } from './constants'

const BORDER_RADIUS_WITH_BORDER = '0 0 var(--chakra-radii-lg) var(--chakra-radii-lg)' as const

export const useListingCardImageStyles = (
  size: ListingCardSizes,
  forceDesktop?: boolean,
  forceMobile?: boolean,
  showBorder?: boolean
) => {
  return useMemo(() => {
    const containerHeight =
      size === ListingCardSizes.LG
        ? '208px'
        : { base: '151px', desktop: forceMobile ? '151px' : '160px' }
    const containerMaxHeight =
      size === ListingCardSizes.LG
        ? '208px'
        : { base: '151px', desktop: forceMobile ? '151px' : '160px' }
    const containerMinHeight =
      size === ListingCardSizes.LG
        ? '208px'
        : { base: '151px', desktop: forceMobile ? '151px' : '160px' }
    const containerBorderRadius = forceDesktop
      ? '0'
      : size === ListingCardSizes.LG
        ? {
            base: BORDER_RADIUS_WITH_BORDER,
            desktop: '0',
          }
        : showBorder
          ? '0'
          : BORDER_RADIUS_WITH_BORDER

    return {
      containerHeight,
      containerMaxHeight,
      containerMinHeight,
      containerBorderRadius,
    }
  }, [size, forceDesktop, forceMobile, showBorder])
}
